<template>
    <div class="topCon">
        <monitor-top-weather></monitor-top-weather>
        <monitor-top-title></monitor-top-title>
        <monitor-top-time></monitor-top-time>
    </div>
</template>

<script>
import MonitorTopTitle from './MonitorTopTitle'
import MonitorTopTime from './MonitorTopTime'
import MonitorTopWeather from './MonitorTopWeather'

export default {
    name: 'MonitorTop',
    components: {
        MonitorTopTitle,
        MonitorTopTime,
        MonitorTopWeather,
    },
    data() {
        return {}
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorTop.vue